export class GameResourceKeys {
    public static readonly GAME_NAME = "game_name";
}
